<template>
  <div class="page-import p_sup_import">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>导入记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="importRecordTable">
        <el-table :data="tableData" class="re_table" :max-height="tableHeight-180" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入名称" prop="StrCustName" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作时间" prop="opTime" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column align="center" label="操作人员" prop="Username" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column align="center" label="导入进度" width="135px">
            <template slot-scope="scope">
              <div>
                <el-steps :active="scope.row.StrImpEdateStr * 0.05" :process-status="(scope.row.StrImpEdateStr == '100') ? 'success' : 'error' " align-center :space="50">
                  <el-step title="解析"
                    status="success">
                  </el-step>
                  <el-step title="完成"
                    :status="(scope.row.StrImpEdateStr=='100') ? 'success' : 'error' ">
                  </el-step>
                </el-steps>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属月份" min-width="120px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.StrImpInstName}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="成功条数" prop="StrRightLine" min-width="80px" fit :show-overflow-tooltip="true"></el-table-column> -->
          <!-- <el-table-column align="center" label="错误条数" prop="StrErrorLine" min-width="80px" fit :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column align="center" label="导入状态" prop="StrErrorLine" min-width="90px">
            <template slot-scope="scope">
              <!-- <div v-show="(scope.row.StrImpEdateStr == '100')&& Number(scope.row.StrErrorLine) > 0" title="点击可查看错误条数" class="errorLi" @click="jumpHandle(scope.row.StrExcelPath)">
                <img src="./../../../assets/employee/images/warning.png" alt='' style="width: 24px" />
                <span style="margin-left: 10px">{{
                  scope.row.StrErrorLine
                }}</span>
              </div> -->
              <div v-if="(scope.row.StrImpEdateStr == '100')">
                <img src="./../../../assets/employee/images/success.png" style="width: 24px">
              </div>
              <div v-else>
                <img src="./../../../assets/employee/images/warning.png" style="width: 24px">
              </div>
              <!-- <el-tooltip v-else effect="dark"
                content="查看错误记录"
                placement="top">
                <el-button type="warning" size="mini" icon="el-icon-message" style="cursor: pointer;" circle @click="jumpHandle(scope.row.StrExcelPath)"></el-button>
              </el-tooltip> -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入结果" min-width="170px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.StrErrmess}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="100px">
            <template slot-scope="scope">
              <el-button size="mini" type="info" plain @click="showDetails(scope.row)" v-if="(scope.row.StrImpEdateStr == '100')">
                查看详情
              </el-button>
              <el-button v-if="(new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())&&(scope.row.StrImpEdateStr!='100')" size="mini" type="info" plain @click="reImportHandle(scope.row)">重新导入</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalnum > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="infoQuery.currpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="infoQuery.pagecount" layout="total,sizes,prev,pager, next, jumper" :total="this.totalnum"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 费用单导入弹框 -->
    <el-dialog title="费用单导入" :visible.sync="importVisible" width="700px" class="res_dialog">
      <div class="p_demand_plan">
        <el-steps :active="curractive" finish-status="success" class="steps-box">
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <div v-if="curractive==0" style="margin-top:15px;padding-bottom:15px;">
          <div class="flex">
            <div>
              <div>归属月份:</div>
              <div class="storageArea">
                <el-date-picker v-model="belongDate" size="small" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
              </div>
            </div>
            <div style="margin-left:150px">
              <div>导入模板下载:</div>
              <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;margin-top:10px">下载模板</el-button>
            </div>
          </div>
        </div>
        <div v-if="curractive==1" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p style="font-weight:bold;">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。</p>
            <p>2. 请将要上传的内容放在第一个sheet中。</p>
            <p>3. 请不要加密模板文件，将导致错误。</p>
            <p>4. 请不要上传带宏的文件，将导致错误。</p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
            <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
          </div>
          <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <!-- 提示 -->
          <p style="color:red;" v-if="isError">{{errorTxt}}</p>
        </div>
        <div v-if="curractive==2" style="margin-top:15px;padding-bottom:15px;">
          <div class="result-box">
            <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
          </div>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importVisible = false" v-if="curractive==0">取消</el-button>
        <el-button size="small" @click="prevSteps" v-if="curractive>0 && curractive<=1">上一步</el-button>
        <el-button type="primary" class="com_dialog_btn" size="small" @click="nextSteps" v-if="curractive<1&&isimp==0">下一步</el-button>
        <el-popconfirm style="margin-left:15px" confirm-button-text='删除旧数据重新导入' cancel-button-text='不删除旧数据，继续导入' icon="el-icon-info" icon-color="red" v-if="curractive<1 && (isimp!=0)" title="该月份已经导入过数据，请问是否删除之前导入的数据重新导入？" @confirm="nextDlt" @cancel="nextSteps">
            <el-button slot="reference" type="primary" size="small">下一步</el-button>
          </el-popconfirm>
        <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-show="curractive==1" :disabled="isUploadSuccess">提交</el-button>
        <el-button size="small" @click="resultHandle" v-if="curractive==2">查看导入结果</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "./../../../common";
import FUN from "./../../../fun";
export default {
  name: "resImportRecord",
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      //禁用日期范围
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
            }
        },
      tableHeight: 0,
      min: 1,
      listLoading: false,
      dialogVisible: false,
      totalnum: 0,
      //下拉筛选
      showDropScreen: -1,
      tableData: [],
      //数据参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        belongMonth: '',
        tableid: "JB_busi_UtilityBill"
      },
      // 定时器
      timer: null,
      //现在时间
      nowDate: '',
      //角色类型
      roleType: '',
      activeName: 'four',
      tabids: [],
      // 导入部分参数
      importVisible:false,
      isimp:0,//是否导入过
      uploadTempQuery:{
        tableid:'JB_busi_UtilityBill',
        fileid:'费用单导入'
      },
      // 导入归属月份
      belongDate:'',
      // 导入显示页面
      curractive: 0,
      ExcelSrc: {
        value: '',
        check: false,
        fileName: ''
      },
      excelpath: '',
      errorTxt: '',
      //是否下载过导入模板
      isDownFeeTemplate: false,
      //表头错误提示
      isError: false,
      fullscreenLoading: false,
      isUploadSuccess: true,
      // 费用单列表
      listQuery:{
        strConstrteamName:'',//施工队名称
        strBusitype:'',//业务类型
        strCity:'',// 城市
        belongMonth:'',// 归属月
        currpage:1,
        perpage:10
      }
    }
  },
  created() {
    if (window.localStorage.getItem('isDownFeeTemplate')) {
      this.calDaysBetween(window.localStorage.getItem('isDownFeeTemplate'))
    }
    if(!this.isNull(this.$route.query.active)){
      this.activeName = this.$route.query.active
    }else{
      this.activeName = 'four'
    }
    this.roleType = localStorage.loginRoletype
    this.calHeight();
    this.nowDate = new Date()
    this.getOpeRecord(this.infoQuery);
    this.dataRefreh();
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
    //   console.log('height', this.tableHeight)
    },
    // 跳转错误详情页
    jumpHandle(val){
      // console.log('ll',val)
      this.$router.push({ name: 'importErrorList',
        params:{
          strExcelPath: val
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    isNullNotZero(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
    },
    // 清除定时器的代码
    clear() {
      clearInterval(this.timer)
      this.timer = null
    },
    // 定时刷新数据函数
    async dataRefreh() {
      const thats = this
      // 计时器正在进行中，退出函数
      if (this.timer != null) {
        return;
      }
      // //如果返回的数据有一个不成功就刷新 反之清除定时器
      // 计时器为空，操作
      this.timer = setInterval(() => {
        // console.log("刷新" + new Date());
        this.min++;
        let errcount = 0;
        for (let index = 0; index < this.tableData.length; index++) {
          const elementData = this.tableData[index];
          let itemDate = elementData.StrImpBdateStr.substring(0, 4) + '-' + elementData.StrImpBdateStr.substring(4, 6) + '-' + elementData.StrImpBdateStr.substring(6, 8) + ' ' + elementData.StrImpBdateStr.substring(8, 10) + ':' + elementData.StrImpBdateStr.substring(10, 12) + ':' + elementData.StrImpBdateStr.substring(12, 14)
          // console.log('1111',new Date().getTime() < new Date((new Date(itemDate)).valueOf() + 360000))
          if (new Date().getTime() < new Date((new Date(itemDate)).valueOf() + 360000)) {
            // if (elementData.StrImpEdateStr == 0) {
            //   errcount = errcount + 1
            // }
            if (elementData.StrImpEdateStr != '100') {
              errcount = errcount + 1
            }
            // else if (elementData.StrImpEdateStr.length < 5) {
            //   errcount = errcount + 1
            // }
          }
        }
        // console.log('errcount',errcount)
        if (errcount > 0) {
          thats.getOpeRecord(thats.infoQuery);
        } else {
          clearInterval(this.timer);
        }
      }, 5000);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.infoQuery.currpage = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    handleSizeChange(val) {
      this.infoQuery.pagecount = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    getOpeRecord(data) {
      this.listLoading = true
      xz.getcrmImpDataList(data).then(res => {
        // console.log('ss', res)
        this.totalnum = parseInt(res.msg.totalnum);
        if (res.msg.data && res.msg.data.length > 0) {
          res.msg.data.forEach(l => {
            var opTime = l.StrImpBdateStr.substring(0, 4) + "/" + l.StrImpBdateStr.substring(4, 6) + "/" + l.StrImpBdateStr.substring(6, 8) + " " + l.StrImpBdateStr.substring(8, 10) + ":" + l.StrImpBdateStr.substring(10, 12);
            l['opTime'] = opTime;
          })
          this.tableData = res.msg.data
        } else {
          this.totalnum = 0
          this.tableData = []
        }
        this.listLoading = false
      })
    },
    // 删除导入
    nextDlt(){
      this.fullscreenLoading = true
      xz.delUtilityBill({belongMonth: this.belongDate}).then(res => {
        // console.log('resetMember', res)
        if (res.status == 'ok') {
          this.$message({ type: 'success', message: '删除成功' })
          this.nextSteps();
          this.fullscreenLoading = false;
        }else{
          this.$message({ type: 'error', message: res.msg })
        }
      });
    },
    // 重新导入
    reImportHandle(row){
      this.importVisible = true
      this.belongDate = row.StrImpInstName
      this.listQuery.belongMonth = this.belongDate
      //判断是否已经导入过
      this.isImportAct()
      this.curractive = 0
      this.errorTxt = ''
      this.ExcelSrc = {
          value: '',
          check: false,
          fileName: ''
      }
    },
    //上一步导入
      prevSteps() {
          this.curractive -= 1
      },
      //下一步导入
      nextSteps() {
        // if (this.active++ > 2) this.active = 0;
        if (this.curractive == 0) {
            if (this.isNull(this.belongDate)) {
                this.$message.warning('请选择归属月份')
                return false
            }
            if (!this.isDownFeeTemplate) {
                this.$message({
                    message: "请先下载导入模板，下一步导入请使用新的模板导入",
                    type: "warning",
                    duration: 5000
                });
                return false
            }
        }
        this.curractive += 1
      },
      //提交导入
      async lastSteps() {
        let that = this
        if (this.ExcelSrc.value == '') {
            this.isUploadSuccess = true
            this.$message({
            message: "请选择文件上传",
            type: "warning"
            });
            this.curractive = 0
            return false
        }else {
            //检查表头是否正确
            let checkData = {
                excelpath: this.excelpath,
                tableid: "JB_busi_UtilityBill",
                fileid: '费用单导入'
            }
            // console.log('checkData', checkData)
            this.fullscreenLoading = true;
            xz.chkcrmTableForm(checkData).then(res => {
            // console.log('checkData',res)
            let resultTxt = res.msg
            // console.log('resultTxt',this.isNull(res))
            if (this.isNull(res.msg)) {
                this.isError = false
                this.isUploadSuccess = false
                const Edata = {
                  tableid: "JB_busi_UtilityBill",
                  excelpath: that.excelpath,
                  impexcel: that.ExcelSrc.fileName,
                  belongMonth: that.belongDate,
                  fileid: '费用单导入'
                }
                xz.anlycrmsisExcelInf(Edata).then(res => {
                    // console.log('Edata', res)
                    if (res.status == 'ok') {
                        this.curractive = 2
                    } else {
                        this.$message('导入错误');
                    }
                    this.fullscreenLoading = false;
                    // this.isUploadSuccess = true
                })
            } else {
                this.isError = true
                this.curractive = 1
                this.isUploadSuccess = true
                this.errorTxt = resultTxt
                //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
                //清空input file值
                var file = document.getElementById("fileInput");
                file.value = '';
                this.fullscreenLoading = false;
            }
            })
        }
      },
      calDaysBetween(date) {
        let startDate = Date.parse(date);
        let endDate = Date.parse(new Date());
        let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        days > 7 ? this.isDownFeeTemplate = false : this.isDownFeeTemplate = true;
      },
      selectMonth(val){
        this.listQuery.belongMonth = val
        //判断是否已经导入过
        this.isImportAct()
      },
      // 判断是否有导入过
      isImportAct(){
        xz.getUtilityBillLists(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.isimp = Number(res.totalcount);
            // console.log('ds', res.totalnum)
          }
        })
      },
      //查看导入结果
      resultHandle() {
        this.importVisible = false
        this.getOpeRecord(this.infoQuery);
      },
      //文件读取
      async importf() {
          const fileInput = this.$refs.upload;
          this.excelpath = ''
          FUN.returnExcelSrc(fileInput).then(src => {
              if (src) {
              // console.log('src0o0', src)
              this.isUploadSuccess = true
              this.$set(this.ExcelSrc, "value", src.src);
              this.$set(this.ExcelSrc, "check", false);
              this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
              // console.log('srccc', this.ExcelSrc)
              //上传excel
              const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
              const formData = new FormData();
              formData.append("pagename", 'empexcel');
              formData.append("action", 'save');
              formData.append("userid", Cookies.get("userid-b"));
              formData.append("entid", Cookies.get("userid-b"));
              formData.append("excel", excelFile, this.ExcelSrc.fileName);
              // console.log('formData', formData)
              xz.uploadCert(formData).then(res => {
                  // console.log('formData', res)
                  if (this.isNull(res) || res == false) {
                      this.$message('上传Excel失败!')
                      this.isUploadSuccess = true
                  } else {
                      this.errorTxt = ''
                      this.excelpath = res;
                      this.isUploadSuccess = false
                      this.$refs['upload'].value = null;
                  }
              });
              } else {
                  this.$message('上传Excel失败!')
              }
          })
        },
      //下载模板
      downLoadHandle() {
          xz.getcrmOutPutMode('JB_busi_UtilityBill','费用单导入').then(res => {
              // console.log('下载模板', res)
              if (res) {
                  this.isDownFeeTemplate = true;
                  window.localStorage.setItem('isDownFeeTemplate', new Date());
                  var d = res.msg.data.StrOutPath
                  d = d.replace("\"", "").replace("\"", "")
                  var path = this.tablePath + d
                  const aTag = document.createElement('a')
                  aTag.href = path
                  aTag.click();
              }
          })
      },
    //查看详情
    showDetails(val) {
      // console.log('val',val)
      let path = val.StrExcelPath;
      let belongMonth = val.StrImpInstName
      let routeUrl = this.$router.resolve(
        { path: '/feeDetail',query:{
          path,
          belongMonth
        }
      });
      window.open(routeUrl.href, '_blank');
      
    }
  },
  beforeDestroy() {
    // 在页面销毁后，清除计时器
    this.clear();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
.page-import .el-tabs--top{
  background-color: #fff;
}
.p_roster_table.el-tabs--card {
    background-color: #fff;
}
.page-import .el-step__title {
  font-size: 13px;
  line-height: 24px;
}
.page-import .el-step__icon {
  width: 20px;
  height: 20px;
  font-size: 12px;
}
.page-import.p_sup_import .dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.changeError {
  padding: 5px 10px;
  border: solid 1px red;
  font-size: 12px;
  color: red;
  border-radius: 4px;
  background-color: #fff;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog .el-dialog__header {
  background: #fff;
}
</style>
<style scoped>
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rIcon {
  font-size: 18px;
  color: #50d4ab;
}
</style>